import { render, staticRenderFns } from "./pushList.vue?vue&type=template&id=59a2d8c1"
import script from "./pushList.vue?vue&type=script&lang=js"
export * from "./pushList.vue?vue&type=script&lang=js"
import style0 from "./pushList.vue?vue&type=style&index=0&id=59a2d8c1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports